import { AbstractModel } from './AbstractModel'
import { Rally } from './Rally'
import { Http } from '@/lib/utils/Http'
import { RallyRound } from './RallyRound'
import { Order } from './Order'

export class CustomerRegister extends AbstractModel {
    static readonly states = [
      { value: 0, name: 'Anmeldung' },
      { value: 1, name: 'Bezahlt' },
      { value: 2, name: 'Fertig' },
      { value: 3, name: 'Storno' },
      { value: 4, name: 'Warteliste' },
      { value: 5, name: 'Unbezahlte Mitglieder' } // Special extra state, is additioanl boolean since value of other states must be kept for reverting, is treated as value "5" in frontend
    ]

    static readonly tshirtsizes = ['S - Herren', 'M - Herren', 'L - Herren', 'XL - Herren', 'XXL - Herren', '3XL - Herren', '4XL - Herren', '5XL - Herren', 'XS - Damen', 'S - Damen', 'M - Damen', 'L - Damen', 'XL - Damen', 'XXL - Damen']
    public id: number|null = null;
    public customerRegisterParentId: number|null = null;
    public rally: Rally|null = null
    public rallyId: number|null = null
    public rallyRound: RallyRound|null = null
    public rallyRoundId: number|null = null
    public teamlead: CustomerRegister|null = null
    public teamType: number|null = null
    public customerId: number|null = null;
    public teamSize: number|null = null
    public phoneCountrynumber: string|null = null
    public phoneFirstnumber: string|null = null
    public phoneLastnumber: string|null = null
    public street: string|null = null
    public zip: string|null = null
    public city: string|null = null
    public countryId: number|null = null
    public tshirtsize: string|null = null
    public price: number|null = null
    public note: string|null = null
    public newsletter = false
    public status: number|null = null;
    public gender: number|null = null;
    public rallies: Rally[] = []
    public waitlist: boolean|null = null;
    public urlParams: string|null = null;
    public teamnumber: number|null = null;
    public teamname: string|null = null;
    public teamdescription: string|null = null;
    public teamId: number|null = null;
    public createdAt: string|null = null;
    public dateAdded: string|null = null;
    public firstname: string|null = null;
    public lastname: string|null = null;
    public email: string|null = null;
    public discount: number|null = null;
    public discountName: string|null = null;
    public hasUnpaidMembers: number|null = null;
    public signatur: string|null = null;
    public orders: Order[] = []
    public orderExists: boolean|null = null;
    members: CustomerRegister[] = []

    getVehicleName (rally: Rally) {
      switch (this.teamType) {
        case 1:
          return 'Karre'
        case 2:
          if (rally.id === 6) {
            return 'Moped'
          }
          return 'Motorrad'
        case 3:
          return 'Boot'
      }
    }

    get statusName () {
      switch (this.status) {
        case 0:
          return 'Anmeldung'
        case 1:
          return 'Bezahlt'
        case 2:
          return 'Fertig'
        case 3:
          return 'Storno'
        case 4:
          return 'Warteliste'
      }
    }

    static updateFromTeamId (teamId: number, customerRegisterUpdate: any) {
      Http.request(`/api/customer-register/team/${teamId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(customerRegisterUpdate)
      })
    }
}
